import { render, staticRenderFns } from "./PredjeniKilometriIPotrosnjaGoriva.vue?vue&type=template&id=e65c97c8&scoped=true&"
import script from "./PredjeniKilometriIPotrosnjaGoriva.vue?vue&type=script&lang=ts&"
export * from "./PredjeniKilometriIPotrosnjaGoriva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65c97c8",
  null
  
)

export default component.exports